import { useState, useEffect, useRef } from 'react'

function fitAspectRect(x, y, w, h, a) {
  // a = desired aspect ratio (width / height)
  let wNew, hNew;

  if (w / h > a) {
    // Too wide — limit by height
    hNew = h;
    wNew = a * hNew;
  } else {
    // Too tall — limit by width
    wNew = w;
    hNew = wNew / a;
  }

  const xNew = x + (w - wNew) / 2;
  const yNew = y + (h - hNew) / 2;

  return { x: xNew, y: yNew, width: wNew, height: hNew };
}

export default function ResizeMarker( props )
{
    const loc = props.loc
    
    const artBoardRef = props.artBoardRef

    const position = props.position
    const setPosition = props.setPosition
    const positionRef = props.positionRef
    const updateLivePosition = props.updateLivePosition

    const fixedAspectRatio = props.fixedAspectRatio
    const isPointDragging = props.isPointDragging
    const artBoardOffset = props.artBoardOffset
    const artBoardZoom = props.artBoardZoom

    const visibleMarker = props.visibleMarker 
    const setVisibleMarker = props.setVisibleMarker

    const markerRef = useRef(null)
    const offset = useRef(null)

    const [ pos, setPos ] = useState(null)
    const [ cursor, setCursor ] = useState(null)

    let lastPositionUpdate = useRef( new Date() )
    const lastValidPosition = useRef( null )

    const reload = ( pp, moving ) => {
        let p = {}

        switch(loc)
        {
            case "TL" :
                p = {x:pp.x, y:pp.y}
                setCursor('nwse-resize')
                break;
            case "TR" :
                p = {x:pp.x + pp.width, y:pp.y}
                setCursor('nesw-resize')
                break; 
            case "BL" :
                p = {x:pp.x, y:pp.y + pp.height}
                setCursor('nesw-resize')
                break;
            case "BR" :
                p = {x:pp.x + pp.width, y:pp.y + pp.height}
                setCursor('nwse-resize')
                break;
            default:
                return
                break
        }
    
        if( moving && markerRef.current != null )
        {
            markerRef.current.style.transform = `translate(${p.x-5}px, ${p.y-5}px)`
        }
        else 
        {
            setPos(p)
        }
        
    }

    useEffect( () => {
        reload( position, false )
    },[ position ])

    useEffect( () => {
        if(visibleMarker == 'all')
        {
            reload( position, false )
        }
    },[ visibleMarker ])

    
    const newShape = (e, old_position) => {
        const rect = artBoardRef.current.getBoundingClientRect();
        const of = offset.current
        var p = { x:(e.clientX - artBoardOffset.x - rect.left) + of.x, 
                  y:(e.clientY - artBoardOffset.y - rect.top) + of.y };

        p.x /= artBoardZoom 
        p.y /= artBoardZoom

        let pp = old_position

        let ap = pp.width / pp.height


        let pp_ = {} 
        
        let x0 = 0 
        let y0 = 0 
        let x1 = 0 
        let y1 = 0

        switch(loc) 
        {
            case "TL" :
                y0 = p.y
                x1 = pp.x + pp.width 
                y1 = pp.y + pp.height

                if( fixedAspectRatio )
                {
                    x0 = x1 - (y1-y0) * ap;
                }
                else
                {
                    x0 = p.x;
                }

                pp_ = {x:x0,y:y0} 

                break
            case "TR" :
                x0 = pp.x
                y0 = p.y
                y1 = pp.y + pp.height

                if( fixedAspectRatio )
                {
                    x1 = x0 + (y1 - y0) * ap;
                }
                else 
                {
                    x1 = p.x 
                }

                pp_ = {x:x0,y:y1}

                break
            case "BL" :
                y0 = pp.y
                x1 = pp.x + pp.width 
                y1 = p.y 

                if( fixedAspectRatio )
                {
                    x0 = x1 - (y1-y0) * ap;
                }
                else 
                {
                    x0 = p.x
                }

                pp_ = {x:x1,y:y0}

                break
            case "BR" :
                x0 = pp.x
                y0 = pp.y
                y1 = p.y 

                if( fixedAspectRatio )
                {
                    x1 = x0 + (y1 - y0) * ap;
                }
                else 
                {
                    x1 = p.x
                }

                pp_ = {x:x1,y:y1}

                break
            default:
                break
        }

        pp.width = x1 - x0 
        pp.height = y1 - y0
        pp.x = x0 
        pp.y = y0

        return pp

    }

    const onPointerDown = (e) => {
        const rect = artBoardRef.current.getBoundingClientRect();

        let p = {x:e.clientX - artBoardOffset.x, y:e.clientY - artBoardOffset.y}
        
        switch(loc)
        {
            case "TL" :
                offset.current = {x:position.x * artBoardZoom - (p.x - rect.left), 
                                  y: position.y * artBoardZoom - (p.y - rect.top)}
                break;
            case "TR" :
                offset.current = {x:(position.x + position.width) * artBoardZoom - (p.x - rect.left), 
                                 y: position.y * artBoardZoom - (p.y - rect.top)}
                break; 
            case "BL" :
                offset.current = {x:position.x * artBoardZoom - (p.x - rect.left), 
                                 y: (position.y + position.height) * artBoardZoom - (p.y - rect.top)}
                break;
            case "BR" :
                offset.current = {x:(position.x + position.width) * artBoardZoom - (p.x - rect.left), 
                                 y: (position.y + position.height) * artBoardZoom - (p.y - rect.top)}
                break;
            default:
                break

        }
 
        positionRef.current = position
 
        e.currentTarget.setPointerCapture?.(e.pointerId);
        e.preventDefault();

        isPointDragging.current = true;
        lastValidPosition.current = null

        setVisibleMarker(loc)
    }


    const onPointerMove = (e) => {
        if (!e.currentTarget.hasPointerCapture?.(e.pointerId)) return;

        if( positionRef.current == null )
        {
            return
        }

        let pp = newShape(e, positionRef.current)

        if( pp.height < 20 || pp.width < 20 )
        {
            return
        }

        lastValidPosition.current = pp

        let now = new Date()
        if(  now - lastPositionUpdate.current > 30 )
        {
            lastPositionUpdate.current = new Date()
            positionRef.current = pp
            updateLivePosition(pp,true)
            reload(pp, true)
        }
    }

    const onPointerUp = (e) => {


        if (e.currentTarget.hasPointerCapture?.(e.pointerId)) {
            e.currentTarget.releasePointerCapture(e.pointerId);

            isPointDragging.current = false;

            let pp = structuredClone(lastValidPosition.current)

            if( pp == null )
            {
                return
            }

            updateLivePosition( pp, false )
            setPosition(pp)
            reload(pp, false)

        }

        e.currentTarget.releasePointerCapture(e.pointerId);

        setVisibleMarker('all')
    }

    if( pos == null )
    {
        return <></>
    }

    if( visibleMarker == 'all' || visibleMarker == loc )
    {

    return (

        <div ref={markerRef}
             style={{ position:'absolute', 
                      top: artBoardOffset.y,
                      left: artBoardOffset.x,
                      transform: `translate(${pos.x-5}px, ${pos.y-5}px)`,
                      height: '10px',
                      width: '10px',
                      border:'2px solid #0077B6',
                      cursor: cursor,
                      zIndex: 500,
                      padding: '0.05px'
             }}
             onPointerDown={onPointerDown}
             onPointerMove={onPointerMove}
             onPointerUp={onPointerUp}

        >
            <div style={{ width:'100%', height:'100%', border:'1px solid #FFFFFF' }}>
            </div>
        </div>

    )
    }

    return <></>
}


